import { canAccessMySkillMatrix, resolveAssignedRoles, ROLE_CODES } from './rolePriority';
import { hasAdminLikeAccess } from './userAccess';

/** Inclusive last day skill nav/page NEW badges are shown (local calendar). */
export const SKILL_NAV_NEW_BADGE_END_DATE = '2026-06-30';

/** Inclusive last day Audit Log nav NEW badges are shown (local calendar). */
export const AUDIT_LOG_NAV_NEW_BADGE_END_DATE = '2026-06-30';

/** @deprecated Use SKILL_NAV_NEW_BADGE_END_DATE */
export const MY_SKILLS_NEW_BADGE_END_DATE = SKILL_NAV_NEW_BADGE_END_DATE;

const MY_SKILLS_PATH = '/skills/my-matrix';

function getSkillNavNewBadgeEndInstant() {
  const [year, month, day] = SKILL_NAV_NEW_BADGE_END_DATE.split('-').map(Number);
  return new Date(year, month - 1, day, 23, 59, 59, 999);
}

/** My Skills, Manage Skills, and Resource Finder NEW badge until end date. */
export function shouldShowSkillNavNewBadge(now = new Date()) {
  return now.getTime() <= getSkillNavNewBadgeEndInstant().getTime();
}

function getAuditLogNavNewBadgeEndInstant() {
  const [year, month, day] = AUDIT_LOG_NAV_NEW_BADGE_END_DATE.split('-').map(Number);
  return new Date(year, month - 1, day, 23, 59, 59, 999);
}

/** Audit Log nav NEW badge until end date. */
export function shouldShowAuditLogNavNewBadge(now = new Date()) {
  return now.getTime() <= getAuditLogNavNewBadgeEndInstant().getTime();
}

/** @deprecated Use shouldShowSkillNavNewBadge */
export function shouldShowMySkillsNewBadge(now = new Date()) {
  return shouldShowSkillNavNewBadge(now);
}

/**
 * Plain employee audience for header discovery (not admin-like, not PM).
 * @param {object|null|undefined} user
 */
export function isMySkillsEmployeeDiscoveryAudience(user) {
  if (!user || !canAccessMySkillMatrix(user)) return false;
  const roles = resolveAssignedRoles(user);
  if (!roles.includes(ROLE_CODES.EMPLOYEE)) return false;
  if (hasAdminLikeAccess(user)) return false;
  if (user.isProjectManager) return false;
  if (user.isReportingManager) return false;
  return true;
}

/**
 * Mobile header chip: employees during the NEW window, not already on My Skills.
 * @param {object|null|undefined} user
 * @param {string} pathname
 * @param {Date} [now]
 */
export function shouldShowMySkillsHeaderDiscovery(user, pathname, now = new Date()) {
  if (!shouldShowSkillNavNewBadge(now)) return false;
  if (!isMySkillsEmployeeDiscoveryAudience(user)) return false;
  if (pathname === MY_SKILLS_PATH || pathname.startsWith(`${MY_SKILLS_PATH}/`)) {
    return false;
  }
  return true;
}

export { MY_SKILLS_PATH };
